import React, { useState, useEffect } from 'react';
import { Modal, Button} from 'react-bootstrap';
import { X, Lock } from 'react-bootstrap-icons';
import { MdDeliveryDining} from 'react-icons/md';
import { FaStore, FaMotorcycle, FaCalendarAlt } from 'react-icons/fa';
import OrderTaker from '../../../Common/OrderTaker/OrderTaker';
import InHouse from './components/InHouse/InHouse';
import DeliveryApps from './components/DeliveryApps/DeliveryApps';
import './CreatePedido.scss';

interface CreatePedidoProps {
    show: boolean;
    handleClose: () => void;
    pedidos: any;
    setPedidos: any;
}

export const CreatePedido: React.FC<CreatePedidoProps> = ({
    show,
    handleClose,
    pedidos,
    setPedidos
}) => {
    // Estados para gestionar las vistas: 'select', 'form', 'order', 'app' y 'done'
    const [viewMode, setViewMode] = useState<'select' | 'form' | 'order' | 'app' | 'done'>('select');
    const [orderContext, setOrderContext] = useState<any>({});


    // Cierra el modal si viewMode pasa a 'done'
    useEffect(() => {
        if (viewMode === 'done') {
            setViewMode('select');
            handleClose();
        }
    }, [viewMode, handleClose]);

    useEffect(() => {
        if (viewMode === 'order' && !show) {
            setViewMode('select');
        }
    }, [show, viewMode]);


    // Renderiza la selección inicial con cuatro opciones
    const renderInitialSelection = () => (
        <Modal.Body>
            <div className='delivery-type-container-selector'>
                <div className='delivery-type-section' onClick={() => setViewMode('form')}>
                    <span className='delivery-type-icon'>
                        <FaStore/>
                    </span>
                    <div className='delivery-type-info'>
                        <span className='delivery-type-title'>Retiro en Local</span>
                        <span className='delivery-type-description'>Recoger en el local</span>
                    </div>
                </div>
                
                <div className='delivery-type-section' onClick={() => setViewMode('app')}>
                    <span className='delivery-type-icon'>
                        <MdDeliveryDining/>
                    </span>
                    <div className='delivery-type-info'>
                        <span className='delivery-type-title'>App Delivery</span>
                        <span className='delivery-type-description'>Rappi, Pedidos Ya, Uber Eats, ...</span>
                    </div>
                </div>
                
                <div className='delivery-type-section disabled'>
                    <span className='delivery-type-icon'>
                        <FaMotorcycle/>
                    </span>
                    <div className='delivery-type-info'>
                        <span className='delivery-type-title'>Reparto Propio</span>
                        <span className='delivery-type-description'>Delivery con repartidor propio</span>
                    </div>
                    <div className='proximamente-badge'>
                        <Lock size={12} />
                        Próximamente
                    </div>
                </div>
                
                <div className='delivery-type-section disabled'>
                    <span className='delivery-type-icon'>
                        <FaCalendarAlt/>
                    </span>
                    <div className='delivery-type-info'>
                        <span className='delivery-type-title'>Programar Pedido</span>
                        <span className='delivery-type-description'>Agendar para fechas futuras</span>
                    </div>
                    <div className='proximamente-badge'>
                        <Lock size={12} />
                        Próximamente
                    </div>
                </div>
            </div>
        </Modal.Body>
    );
    

    return (
        <Modal show={show} onHide={handleClose} className="create-pedido-modal" centered>
            <Modal.Header>
                <div className="form-modal-title-container">
                    <Modal.Title className="form-modal-title">Crear Pedido</Modal.Title>
                </div>
                <Button variant="none" onClick={handleClose}>
                    <X size={24} />
                </Button>
            </Modal.Header>

            {viewMode === 'select' && renderInitialSelection()}
            {viewMode === 'form' && <InHouse setViewMode={setViewMode} 
                                            setOrderContext={setOrderContext} 
                                            handleClose={handleClose}
                                            show={show}/>}
            {viewMode === 'app' && <DeliveryApps setViewMode={setViewMode} 
                                                    setOrderContext={setOrderContext} 
                                                    handleClose={handleClose}
                                                    show={show}/>}
            {viewMode === 'order' && (
                <OrderTaker
                    pedido_type="Delivery"
                    orderContext={orderContext}
                    setViewMode={setViewMode}
                />
            )}

        </Modal>
    );
};

export default CreatePedido;
